export const toggleSetItem = <T>(set: Set<T>, item: T): void => {
  if (set.has(item)) {
    set.delete(item);
  } else {
    set.add(item);
  }
};

export const changeSetItem = <T>(
  set: Set<T>,
  item: T,
  needIncluded: boolean,
): void => {
  if (needIncluded) {
    set.add(item);
  } else {
    set.delete(item);
  }
};
